var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGiniDocument = function SvgGiniDocument(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "#757B8A",
    style: {
      width: 18,
      height: 19
    },
    viewBox: "0 0 18 19",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 8.8c.7-.4 1.4-.5 2.2-.5h.3L12 8c0-.4-.3-.7-.7-.7H5.4c-.4 0-.7.3-.7.8s.3.7.7.7zM4.7 10.5c0 .4.3.7.7.7h2.3l.1-.1c.2-.3.4-.7.6-.9l.4-.4H5.4c-.4 0-.7.3-.7.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 17.3V17h-.1c-.3 0-.5-.1-.7-.1-.4-.1-.8-.3-1.2-.5-.2-.1-.4-.2-.5-.3H3.5c-.1 0-.2-.1-.2-.2V2.1c0-.1.1-.2.2-.2h6.1v2.2c0 .9.8 1.7 1.7 1.7h2.2v2.9l.1.1c.3.2.7.4.9.6l.4.4V5.1c0-.2-.1-.4-.2-.5L10.8.7c-.1-.1-.3-.2-.5-.2H3.5c-.9 0-1.7.8-1.7 1.7v13.7c0 .9.8 1.7 1.7 1.7h8.2zM11 2.9l1.4 1.4h-1.1c-.1 0-.2-.1-.2-.2V2.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.4 16.3-1.6-1.4c1-1.4.9-3.4-.4-4.6-.7-.7-1.6-1.1-2.5-1.1-1 0-1.9.4-2.5 1.1C8 11.7 8 14 9.4 15.4c1.2 1.2 3 1.4 4.4.5l1.7 1.5c.4.3.9.4 1.2.1.2-.4.1-.9-.3-1.2m-2.9-1.9c-.9.9-2.3.9-3.2 0s-.9-2.3 0-3.2c.4-.4 1-.7 1.6-.7s1.2.2 1.6.7c.8.8.8 2.3 0 3.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGiniDocument);
export default ForwardRef;